/**
 * RAKNIDA · rk-artist.js
 * PG-10 artist profile — tabs, hash routing, share, works filter/sort/pagination, wishlist
 */
(function () {
  var WISH_KEY = 'rk_wishlist';
  var PER_PAGE = 12;

  function readWishlist() {
    try {
      var raw = localStorage.getItem(WISH_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(ids) {
    try {
      localStorage.setItem(WISH_KEY, JSON.stringify(ids));
    } catch (e) { /* ignore */ }
  }

  function init(root) {
    if (!root || root.dataset.rkApReady) return;
    root.dataset.rkApReady = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-rk-ap-tab]'));
    var tabContent = root.querySelector('.rk-ap-tabs__content');
    var panes = tabContent
      ? tabContent.querySelectorAll('[data-rk-ap-pane]')
      : root.querySelectorAll('[data-rk-ap-pane]');
    var tabKeys = tabs.map(function (b) {
      return b.getAttribute('data-rk-ap-tab');
    });

    function activate(key, opts) {
      opts = opts || {};
      if (tabKeys.indexOf(key) === -1) key = tabKeys[0] || 'works';

      tabs.forEach(function (btn) {
        var on = btn.getAttribute('data-rk-ap-tab') === key;
        btn.classList.toggle('on', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
        btn.tabIndex = on ? 0 : -1;
      });
      panes.forEach(function (pane) {
        var on = pane.getAttribute('data-rk-ap-pane') === key;
        pane.classList.toggle('on', on);
        if (on) pane.removeAttribute('hidden');
        else pane.setAttribute('hidden', '');
      });

      if (!opts.skipHash && typeof history !== 'undefined' && history.replaceState) {
        history.replaceState(null, '', '#' + key);
      }

      if (!opts.skipScroll && key !== 'works') {
        var bar = root.querySelector('#rk-ap-tabs');
        if (bar && typeof bar.scrollIntoView === 'function') {
          bar.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      if (key === 'reviews') {
        root.dispatchEvent(new CustomEvent('rk-ap-reviews-open'));
      }
    }

    function fromHash() {
      var h = (window.location.hash || '').replace(/^#/, '');
      if (tabKeys.indexOf(h) !== -1) activate(h, { skipHash: true });
      else activate(tabKeys[0] || 'works', { skipHash: true });
    }

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activate(btn.getAttribute('data-rk-ap-tab'));
      });
    });

    var tablist = root.querySelector('[role="tablist"]');
    if (tablist) {
      tablist.addEventListener('keydown', function (e) {
        var activeKey = null;
        tabs.forEach(function (b) {
          if (b.getAttribute('aria-selected') === 'true') {
            activeKey = b.getAttribute('data-rk-ap-tab');
          }
        });
        var idx = tabKeys.indexOf(activeKey);
        if (idx < 0) return;
        var next = null;
        if (e.key === 'ArrowRight') next = tabKeys[(idx + 1) % tabKeys.length];
        else if (e.key === 'ArrowLeft') next = tabKeys[(idx - 1 + tabKeys.length) % tabKeys.length];
        else if (e.key === 'Home') next = tabKeys[0];
        else if (e.key === 'End') next = tabKeys[tabKeys.length - 1];
        if (next) {
          e.preventDefault();
          activate(next);
          var el = document.getElementById('tab-' + next);
          if (el) el.focus();
        }
      });
    }

    window.addEventListener('hashchange', fromHash);
    fromHash();

    root.querySelectorAll('[data-rk-ap-goto]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-rk-ap-goto');
        activate(key);
        var bar = root.querySelector('#rk-ap-tabs');
        if (bar) bar.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    wireGotoFilters(root, activate);

    /* Heritage badge on peer cards — navigate to heritage page, not parent artist link */
    root.addEventListener('click', function (e) {
      var herLink = e.target.closest('[data-rk-ah-her-link]');
      if (!herLink || !root.contains(herLink)) return;
      var href = herLink.getAttribute('data-rk-ah-her-link');
      if (!href) return;
      e.preventDefault();
      e.stopPropagation();
      window.location.href = href;
    });

    initFilms(root);
    initWatchCta(root);

    /* —— Share —— */
    var share = root.querySelector('[data-rk-ap-share]');
    if (share) {
      var toggle = share.querySelector('[data-rk-ap-share-toggle]');
      var menu = share.querySelector('[data-rk-ap-share-menu]');
      function closeShare() {
        if (!menu || !toggle) return;
        menu.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
      }
      function openShare() {
        if (!menu || !toggle) return;
        menu.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
      }
      if (toggle && menu) {
        toggle.addEventListener('click', function (e) {
          e.stopPropagation();
          if (menu.hasAttribute('hidden')) openShare();
          else closeShare();
        });
        document.addEventListener('click', function (e) {
          if (!share.contains(e.target)) closeShare();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') closeShare();
        });
      }
      var copyBtn = share.querySelector('[data-rk-ap-copy]');
      if (copyBtn) {
        var copyLabel = copyBtn.querySelector('[data-rk-ap-copy-label]');
        var copyIcon = copyBtn.querySelector('[data-rk-ap-copy-icon]');
        var checkIcon = copyBtn.querySelector('[data-rk-ap-check-icon]');
        copyBtn.addEventListener('click', function () {
          var url = copyBtn.getAttribute('data-rk-ap-copy') || '';
          var done = function () {
            copyBtn.classList.add('rk-ap-share__copied');
            if (copyLabel) copyLabel.textContent = 'Link copied';
            if (copyIcon) copyIcon.setAttribute('hidden', '');
            if (checkIcon) checkIcon.removeAttribute('hidden');
            setTimeout(function () {
              copyBtn.classList.remove('rk-ap-share__copied');
              if (copyLabel) copyLabel.textContent = 'Copy link';
              if (copyIcon) copyIcon.removeAttribute('hidden');
              if (checkIcon) checkIcon.setAttribute('hidden', '');
            }, 1800);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(done).catch(done);
          } else {
            done();
          }
        });
      }
    }

    /* —— Wishlist —— */
    function syncWishButtons() {
      var ids = readWishlist();
      root.querySelectorAll('[data-rk-ap-wish]').forEach(function (btn) {
        var id = String(btn.getAttribute('data-rk-ap-wish'));
        var on = ids.indexOf(id) !== -1;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        var title = btn.getAttribute('data-title') || 'work';
        btn.setAttribute(
          'aria-label',
          on ? 'Remove ' + title + ' from wishlist' : 'Add ' + title + ' to wishlist'
        );
      });
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rk-ap-wish]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation();
      var id = String(btn.getAttribute('data-rk-ap-wish'));
      var ids = readWishlist();
      var i = ids.indexOf(id);
      if (i === -1) ids.push(id);
      else ids.splice(i, 1);
      writeWishlist(ids);
      syncWishButtons();
    });
    syncWishButtons();

    /* —— Works filter / sort / pagination —— */
    var worksPane = root.querySelector('[data-rk-ap-pane="works"]');
    if (worksPane) {
      initWorks(worksPane);
    }
  }

  function initWorks(pane) {
    var cards = Array.prototype.slice.call(
      pane.querySelectorAll('.rk-ap-works-grid .rk-pc[data-product-id], .rk-ap-works-grid .rk-ap-pc[data-id]')
    );
    if (!cards.length) return;

    var state = { tier: 'all', sort: 'default', page: 1 };

    var pills = pane.querySelectorAll('[data-rk-ap-filter]');
    var sortSel = pane.querySelector('[data-rk-ap-sort]');
    var summaryEl = pane.querySelector('[data-rk-ap-summary]');
    var grid = pane.querySelector('[data-rk-ap-works-grid]');
    var pagination = pane.querySelector('[data-rk-ap-pagination]');
    var empty = pane.querySelector('[data-rk-ap-empty-filter]');

    function tierCountsFromCards() {
      var counts = { all: cards.length, open: 0, limited: 0, collector: 0 };
      cards.forEach(function (c) {
        var t = (c.getAttribute('data-tier') || 'open').toLowerCase();
        if (t === 'limited') counts.limited += 1;
        else if (t === 'collector') counts.collector += 1;
        else if (t === 'open') counts.open += 1;
      });
      return counts;
    }

    function applyPillCounts(counts) {
      pills.forEach(function (p) {
        var f = p.getAttribute('data-rk-ap-filter');
        var n = p.querySelector('.rk-ap-works-pill__n');
        if (!n || !f) return;
        if (f === 'all') n.textContent = String(counts.all);
        if (f === 'open') n.textContent = String(counts.open);
        if (f === 'limited') n.textContent = String(counts.limited);
        if (f === 'collector') n.textContent = String(counts.collector);
      });
      var profile = pane.closest('[data-rk-artist-profile]');
      if (!profile) return;
      var tabN = profile.querySelector('#tab-works .rk-ap-tab__n');
      if (tabN) tabN.textContent = '(' + counts.all + ')';
      profile.querySelectorAll('.rk-ap-stat').forEach(function (stat) {
        var lab = stat.querySelector('.rk-ap-stat__l');
        var val = stat.querySelector('.rk-ap-stat__v');
        if (lab && val && lab.textContent.trim() === 'Works') {
          val.textContent = String(counts.all);
        }
      });
    }

    var pillCounts = tierCountsFromCards();
    applyPillCounts(pillCounts);

    function filtered() {
      var list = cards.filter(function (c) {
        if (state.tier === 'all') return true;
        return c.getAttribute('data-tier') === state.tier;
      });

      list.sort(function (a, b) {
        if (state.sort === 'price-low') {
          return Number(a.getAttribute('data-price') || 0) - Number(b.getAttribute('data-price') || 0);
        }
        if (state.sort === 'price-high') {
          return Number(b.getAttribute('data-price') || 0) - Number(a.getAttribute('data-price') || 0);
        }
        if (state.sort === 'newest') {
          return Number(b.getAttribute('data-year') || 0) - Number(a.getAttribute('data-year') || 0);
        }
        /* Featured: keep source order */
        return cards.indexOf(a) - cards.indexOf(b);
      });
      return list;
    }

    function render() {
      var list = filtered();
      var totalPages = Math.max(1, Math.ceil(list.length / PER_PAGE));
      if (state.page > totalPages) state.page = totalPages;
      var start = (state.page - 1) * PER_PAGE;
      var end = start + PER_PAGE;

      /* Re-order DOM to match filter/sort; only current page is visible */
      list.forEach(function (c, i) {
        c.classList.toggle('is-hidden', i < start || i >= end);
        if (grid) grid.appendChild(c);
      });
      cards.forEach(function (c) {
        if (list.indexOf(c) === -1) {
          c.classList.add('is-hidden');
          if (grid) grid.appendChild(c);
        }
      });

      if (summaryEl) {
        var tierLabel = '';
        if (state.tier === 'open') tierLabel = 'Open Edition ';
        else if (state.tier === 'collector') tierLabel = 'Collector Edition ';
        else if (state.tier === 'limited') tierLabel = 'Limited Edition ';
        var text = list.length + ' ' + tierLabel + 'works';
        if (totalPages > 1) text += ' · Page ' + state.page + ' of ' + totalPages;
        summaryEl.textContent = text;
      }

      if (empty) {
        if (list.length === 0) empty.removeAttribute('hidden');
        else empty.setAttribute('hidden', '');
      }
      if (grid) {
        grid.style.display = list.length === 0 ? 'none' : '';
      }

      if (pagination) {
        if (totalPages <= 1 || list.length === 0) {
          pagination.innerHTML = '';
          pagination.setAttribute('hidden', '');
        } else {
          pagination.removeAttribute('hidden');
          var html = '';
          html +=
            '<button type="button" class="rk-ap-page-btn" data-rk-ap-page="prev" ' +
            (state.page === 1 ? 'disabled' : '') +
            ' aria-label="Previous page">‹</button>';
          for (var p = 1; p <= totalPages; p++) {
            html +=
              '<button type="button" class="rk-ap-page-btn' +
              (p === state.page ? ' on' : '') +
              '" data-rk-ap-page="' +
              p +
              '" aria-label="Page ' +
              p +
              '"' +
              (p === state.page ? ' aria-current="page"' : '') +
              '>' +
              p +
              '</button>';
          }
          html +=
            '<button type="button" class="rk-ap-page-btn" data-rk-ap-page="next" ' +
            (state.page === totalPages ? 'disabled' : '') +
            ' aria-label="Next page">›</button>';
          pagination.innerHTML = html;
        }
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        state.tier = pill.getAttribute('data-rk-ap-filter') || 'all';
        state.page = 1;
        pills.forEach(function (p) {
          var on = p === pill;
          var f = p.getAttribute('data-rk-ap-filter');
          p.classList.toggle('on', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
          p.classList.toggle('on-le', on && f === 'limited');
          p.classList.toggle('on-co', on && f === 'collector');
        });
        render();
      });
    });

    if (sortSel) {
      sortSel.addEventListener('change', function () {
        state.sort = sortSel.value;
        state.page = 1;
        render();
      });
    }

    if (pagination) {
      pagination.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-rk-ap-page]');
        if (!btn || btn.disabled) return;
        var v = btn.getAttribute('data-rk-ap-page');
        var list = filtered();
        var totalPages = Math.max(1, Math.ceil(list.length / PER_PAGE));
        if (v === 'prev') state.page = Math.max(1, state.page - 1);
        else if (v === 'next') state.page = Math.min(totalPages, state.page + 1);
        else state.page = parseInt(v, 10) || 1;
        render();
      });
    }

    var showAll = pane.querySelector('[data-rk-ap-show-all]');
    if (showAll) {
      showAll.addEventListener('click', function () {
        var allPill = pane.querySelector('[data-rk-ap-filter="all"]');
        if (allPill) allPill.click();
      });
    }

    render();
  }

  function wireGotoFilters(root, activate) {
    root.querySelectorAll('[data-rk-ap-goto-filter]').forEach(function (el) {
      el.addEventListener('click', function () {
        var tier = el.getAttribute('data-rk-ap-goto-filter') || 'all';
        activate('works', { push: true });
        var pill = root.querySelector('[data-rk-ap-filter="' + tier + '"]');
        if (pill) {
          window.requestAnimationFrame(function () {
            pill.click();
          });
        }
        var bar = root.querySelector('#rk-ap-tabs');
        if (bar && typeof bar.scrollIntoView === 'function') {
          bar.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function youtubeThumb(url) {
    if (!url) return '';
    var m = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([\w-]{6,})/);
    return m ? 'https://img.youtube.com/vi/' + m[1] + '/hqdefault.jpg' : '';
  }

  function youtubeId(url) {
    if (!url) return '';
    var m = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([\w-]{6,})/);
    return m ? m[1] : '';
  }

  function vimeoId(url) {
    if (!url) return '';
    var m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return m ? m[1] : '';
  }

  function formatFilmDur(seconds) {
    if (!isFinite(seconds) || seconds <= 0) return '';
    var sec = Math.round(seconds);
    var h = Math.floor(sec / 3600);
    var m = Math.floor((sec % 3600) / 60);
    var s = sec % 60;
    var pad = function (n) {
      return n < 10 ? '0' + n : String(n);
    };
    if (h > 0) return h + ':' + pad(m) + ':' + pad(s);
    return m + ':' + pad(s);
  }

  function setFilmDurLabel(btn, dur) {
    if (!btn || !dur) return;
    var prev = btn.getAttribute('data-rk-ap-film-dur') || '';
    if (prev === dur) return;
    btn.setAttribute('data-rk-ap-film-dur', dur);
    var item = btn.closest('.rk-ap-film__item');
    var span = item && item.querySelector('.rk-ap-film__cap span');
    if (!span) return;
    var title = btn.getAttribute('data-rk-ap-film-title') || '';
    var role = btn.getAttribute('data-rk-ap-film-role') || '';
    var base = title ? role || 'Artist film' : 'Artist film — pending';
    span.textContent = base + ' · ' + dur;
  }

  var ytApiPromise = null;
  function loadYoutubeApi() {
    if (window.YT && window.YT.Player) {
      return Promise.resolve(window.YT);
    }
    if (ytApiPromise) return ytApiPromise;
    ytApiPromise = new Promise(function (resolve) {
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () {
        if (typeof prev === 'function') prev();
        resolve(window.YT);
      };
      if (!document.querySelector('script[data-rk-yt-api]')) {
        var s = document.createElement('script');
        s.src = 'https://www.youtube.com/iframe_api';
        s.async = true;
        s.setAttribute('data-rk-yt-api', '1');
        document.head.appendChild(s);
      }
      var tries = 0;
      var poll = setInterval(function () {
        tries += 1;
        if (window.YT && window.YT.Player) {
          clearInterval(poll);
          resolve(window.YT);
        } else if (tries > 80) {
          clearInterval(poll);
          resolve(null);
        }
      }, 50);
    });
    return ytApiPromise;
  }

  function syncFilmDuration(btn) {
    var src = btn.getAttribute('data-rk-ap-film-src') || '';
    var embed = btn.getAttribute('data-rk-ap-film-embed') || '';
    var thumbVid = btn.querySelector('.rk-ap-film__thumb-vid');

    function fromVideoEl(vidEl) {
      if (!vidEl) return false;
      var apply = function () {
        if (vidEl.duration && isFinite(vidEl.duration)) {
          setFilmDurLabel(btn, formatFilmDur(vidEl.duration));
        }
      };
      if (vidEl.readyState >= 1 && vidEl.duration) apply();
      else {
        vidEl.addEventListener('loadedmetadata', apply, { once: true });
      }
      return true;
    }

    if (fromVideoEl(thumbVid)) return;

    if (src) {
      var probe = document.createElement('video');
      probe.preload = 'metadata';
      probe.muted = true;
      probe.playsInline = true;
      probe.src = src;
      probe.addEventListener(
        'loadedmetadata',
        function () {
          setFilmDurLabel(btn, formatFilmDur(probe.duration));
          probe.removeAttribute('src');
          try {
            probe.load();
          } catch (e) { /* ignore */ }
        },
        { once: true }
      );
      return;
    }

    var vid = vimeoId(embed);
    if (vid) {
      fetch('https://vimeo.com/api/oembed.json?url=' + encodeURIComponent('https://vimeo.com/' + vid))
        .then(function (r) {
          return r.json();
        })
        .then(function (d) {
          if (d && d.duration) setFilmDurLabel(btn, formatFilmDur(d.duration));
          if (d && d.thumbnail_url) {
            var ph = btn.querySelector('.rk-ap-film__ph--poster');
            if (ph && !btn.getAttribute('data-rk-ap-film-poster')) {
              setFilmPoster(btn, ph, d.thumbnail_url);
            }
          }
        })
        .catch(function () { /* ignore */ });
      return;
    }

    var yt = youtubeId(embed);
    if (!yt) return;
    loadYoutubeApi().then(function (YT) {
      if (!YT || !YT.Player) return;
      var host = document.createElement('div');
      host.setAttribute('aria-hidden', 'true');
      host.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);';
      document.body.appendChild(host);
      var settled = false;
      var finish = function (player) {
        if (settled) return;
        settled = true;
        try {
          var d = player && typeof player.getDuration === 'function' ? player.getDuration() : 0;
          if (d > 0) setFilmDurLabel(btn, formatFilmDur(d));
        } catch (e) { /* ignore */ }
        try {
          if (player && typeof player.destroy === 'function') player.destroy();
        } catch (e2) { /* ignore */ }
        if (host.parentNode) host.parentNode.removeChild(host);
      };
      try {
        var player = new YT.Player(host, {
          width: 1,
          height: 1,
          videoId: yt,
          playerVars: { autoplay: 0, controls: 0, mute: 1 },
          events: {
            onReady: function (e) {
              finish(e.target);
            },
            onError: function () {
              finish(null);
            }
          }
        });
        setTimeout(function () {
          finish(player);
        }, 8000);
      } catch (e) {
        finish(null);
      }
    });
  }

  function setFilmPoster(btn, ph, url) {
    if (!url || !ph) return;
    ph.style.backgroundImage = 'url(' + url.replace(/"/g, '\\"') + ')';
    ph.removeAttribute('data-rk-ap-film-ph-wait');
    btn.setAttribute('data-rk-ap-film-poster', url);
  }

  function initFilmThumbs(section) {
    section.querySelectorAll('[data-rk-ap-film-open]').forEach(function (btn) {
      var poster = btn.getAttribute('data-rk-ap-film-poster') || '';
      var src = btn.getAttribute('data-rk-ap-film-src') || '';
      var embed = btn.getAttribute('data-rk-ap-film-embed') || '';
      var ph = btn.querySelector('.rk-ap-film__ph--poster');
      if (!ph) return;

      if (!poster) {
        var ref = embed || src;
        var yt = youtubeThumb(ref);
        if (yt) {
          setFilmPoster(btn, ph, yt);
          poster = yt;
        }
      }

      if (!poster && btn.hasAttribute('data-rk-ap-film-needs-embed-thumb')) {
        var vid = vimeoId(embed || src);
        if (vid) {
          fetch('https://vimeo.com/api/oembed.json?url=' + encodeURIComponent('https://vimeo.com/' + vid))
            .then(function (r) {
              return r.json();
            })
            .then(function (d) {
              if (d && d.thumbnail_url) setFilmPoster(btn, ph, d.thumbnail_url);
            })
            .catch(function () { /* ignore */ });
        }
      }

      var vidEl = ph.querySelector('.rk-ap-film__thumb-vid');
      if (vidEl) {
        var seekThumb = function () {
          try {
            var t = vidEl.duration && isFinite(vidEl.duration) ? Math.min(1, vidEl.duration * 0.08) : 0.5;
            vidEl.currentTime = t;
          } catch (e) { /* ignore */ }
        };
        vidEl.addEventListener('loadeddata', seekThumb, { once: true });
        vidEl.addEventListener('loadedmetadata', seekThumb, { once: true });
      }

      syncFilmDuration(btn);
    });
  }

  function toEmbed(url) {
    if (!url) return '';
    var m = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]{6,})/);
    if (m) return 'https://www.youtube.com/embed/' + m[1];
    m = url.match(/vimeo\.com\/(\d+)/);
    if (m) return 'https://player.vimeo.com/video/' + m[1];
    return url;
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function rkTrack(ev, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: ev }, data || {}));
    } catch (e) { /* ignore */ }
  }

  function initWatchCta(root) {
    var btn = root.querySelector('[data-rk-ap-watch]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var sec = document.getElementById('studio-films');
      if (!sec) return;
      rkTrack('watch_cta_click', {});
      var grid = sec.querySelector('.rk-ap-film__grid') || sec;
      var rm = prefersReducedMotion();
      grid.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'center' });
      setTimeout(function () {
        var r = grid.getBoundingClientRect();
        var y = r.top + window.scrollY - Math.max(0, (window.innerHeight - r.height) / 2);
        window.scrollTo({ top: y, behavior: 'auto' });
        if (!rm) {
          sec.classList.add('rk-ap-film-hi');
          setTimeout(function () {
            sec.classList.remove('rk-ap-film-hi');
          }, 1700);
        }
      }, rm ? 60 : 760);
    });
  }

  function initFilms(root) {
    var section = root.querySelector('[data-rk-ap-films]');
    if (!section) return;

    var lb = section.querySelector('[data-rk-ap-film-lb]');
    var lbBody = section.querySelector('[data-rk-ap-film-lb-body]');
    var closeBtn = section.querySelector('[data-rk-ap-film-close]');
    var lastTrigger = null;

    function closeLb() {
      if (!lb || !lbBody) return;
      lb.setAttribute('hidden', '');
      lbBody.innerHTML = '';
      document.body.style.overflow = '';
      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    }

    function openLb(btn) {
      if (!lb || !lbBody) return;
      lastTrigger = btn;
      var src = btn.getAttribute('data-rk-ap-film-src') || '';
      var embed = btn.getAttribute('data-rk-ap-film-embed') || '';
      var poster = btn.getAttribute('data-rk-ap-film-poster') || '';
      var title = btn.getAttribute('data-rk-ap-film-title') || '';
      var role = btn.getAttribute('data-rk-ap-film-role') || '';
      var dur = btn.getAttribute('data-rk-ap-film-dur') || '';
      var cap = title || role;
      if (dur) cap += ' · ' + dur;

      var html = '';
      if (src) {
        html =
          '<video controls autoplay playsinline src="' +
          src.replace(/"/g, '&quot;') +
          '"' +
          (poster ? ' poster="' + poster.replace(/"/g, '&quot;') + '"' : '') +
          ' style="width:100%;aspect-ratio:16/9;background:#000"></video>';
      } else if (embed) {
        html =
          '<iframe src="' +
          toEmbed(embed).replace(/"/g, '&quot;') +
          '" title="' +
          (title || role).replace(/"/g, '&quot;') +
          '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="width:100%;aspect-ratio:16/9;border:0;background:#000"></iframe>';
      } else if (poster) {
        html =
          '<div class="rk-ap-film__lb-placeholder" style="background-image:url(' +
          poster.replace(/"/g, '&quot;') +
          ')"><span class="rk-ap-film__tag">Film placeholder — arriving with the artist\'s onboarding</span></div>';
      }
      html += '<p class="rk-ap-film__lb-cap">' + cap + '</p>';
      lbBody.innerHTML = html;
      lb.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';

      rkTrack('film_lightbox_open', {
        index: btn.getAttribute('data-rk-ap-film-index'),
        role: role
      });

      if (closeBtn) closeBtn.focus();

      var vid = lbBody.querySelector('video');
      if (vid) {
        vid.addEventListener('play', function () {
          rkTrack('film_play', {
            index: btn.getAttribute('data-rk-ap-film-index'),
            role: role
          });
        });
      }
    }

    section.querySelectorAll('[data-rk-ap-film-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openLb(btn);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeLb);

    if (lb) {
      lb.addEventListener('click', function (e) {
        if (e.target === lb) closeLb();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lb && !lb.hasAttribute('hidden')) closeLb();
    });

    initFilmThumbs(section);
  }

  function boot() {
    document.querySelectorAll('[data-rk-artist-profile]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-rk-artist-profile]').forEach(function (el) {
      delete el.dataset.rkApReady;
    });
    boot();
  });
})();
